export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL
export const API_URL = process.env.REACT_APP_API_URL
export const API_URL_ADMIN = process.env.REACT_APP_API_URL_ADMIN
export const PUBLIC_URL = process.env.REACT_APP_API_URL_PUBLIC
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL
export const MANAGER_URL = process.env.REACT_APP_MANAGER_URL
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY
export const MAIN_DOMAIN = "https://gopowerev.com"
